import ConsentEdit from './ConsentEdit'
import ConsentEmailConfirmed from './ConsentEmailConfirmed'
import ConsentMain from './ConsentMain'
import ConsentNew from './ConsentNew'
import ConsentReceiptDetails from './ConsentReceiptDetails'
import ConsentReceiptMain from './ConsentReceiptMain'
import ConsentReceiptNew from './ConsentReceiptNew'
import ConsentShow from './ConsentShow'

export default {
  ConsentEdit,
  ConsentEmailConfirmed,
  ConsentMain,
  ConsentNew,
  ConsentReceiptDetails,
  ConsentReceiptMain,
  ConsentReceiptNew,
  ConsentShow,
}
